<template>
  <div>

    <div>
      <keep-alive>
        <router-view :query="query" v-if="$route.meta.keepAlive"/>
      </keep-alive>
      <!-- 此处是为添加了keepAlive=false 的路由默认不缓存 -->
      <router-view :query="query" v-if="!$route.meta.keepAlive"/>
    </div>

<div class="zc">
  <i>本服务由苏州芯爱信息科技有限公司支持</i>
  <i>服务电话：15995256355</i>
</div>
<div  class="zc" @click="handleBeiAn">
  <i >苏ICP备2023019203号-2</i>
     <i ><img width="18" height="20" src="@/assets/beian.png"/>苏公网安备32050602013649号</i>
</div>
    <div v-show="!hiddenTabbar">
      <div class="zc" style="height: 50px"></div>
      <van-tabbar v-model="active">
        <van-tabbar-item
            v-for="(item, index) in tabList"
            :key="index"
            :to="item.path">
            {{item.name}}
            <template #icon="props">
              <img :src="props.active ? item.active : item.inactive"/>
            </template>
        </van-tabbar-item>
      </van-tabbar>
    </div>



  </div>
</template>

<script>
  import Utils from "@/js/common/utils";

  export default {
    name: "BasicLayout",
    data() {
      return {
        type: '',
        active: 0,
        tabList: [
          {
            name: '机构',
            inactive: require('@/assets/kc.png'),
            active: require('@/assets/kc-active.png'),
            path: '/organization'
          },
          {
            name: '选课',
            inactive: require('@/assets/kc.png'),
            active: require('@/assets/kc-active.png'),
            path: '/courseSelection'
          },
          {
            name: '课程',
            inactive: require('@/assets/list.png'),
            active: require('@/assets/list-active.png'),
            path: '/course'
          },
          {
            name: '我的',
            inactive: require('@/assets/my.png'),
            active: require('@/assets/my-active.png'),
            path: '/my'
          },
        ],
        hiddenTabbar: false,
        query: {}
      }
    },
    watch: {
      $route: {
        handler: function (val) {
          this.routeRefresh(val)
        },
        // 深度观察监听
        deep: true
      }
    },
    created() {
      const data = Utils.getLocal('identity') || '{}';
      const identity = JSON.parse(data);
      if (identity.value === 4 || identity.value === 2) {
        this.tabList = [
          {
            name: '课程',
            inactive: require('@/assets/list.png'),
            active: require('@/assets/list-active.png'),
            path: '/course'
          },
          {
            name: '我的',
            inactive: require('@/assets/my.png'),
            active: require('@/assets/my-active.png'),
            path: '/my'
          },
        ]
      }
      this.routeRefresh(this.$route)
    },
    methods: {
      handleBeiAn () {
        window.open('https://beian.miit.gov.cn/#/Integrated/index')
      },
      routeRefresh(route) {
        const index = this.tabList.findIndex(i => i.path === route.path)
        if (index > -1) {
          this.active = index
        }
        if (route.meta && route.meta.hiddenTabbar) {
          this.hiddenTabbar = route.meta.hiddenTabbar
        } else {
          this.hiddenTabbar = false
        }

        this.query = route.query
      },
    }
  }
</script>

<style>
.zc{
  width: 100%;
  color: #0a0a0a;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: #f2f6fd;
  padding: 15px 0;
  display: flex;
  flex-direction: column;
}
.zc i{
  font-style: normal;
  padding-top:5px;
  font-size: 14px;
  color: #666666;
}
</style>
